/* eslint-disable @typescript-eslint/no-explicit-any */
export enum TruckTypeSR {
    PickUp = <any>'Pikap',
    Van = <any>'Kombi',
    RegularTruck = <any>'Kamion',
    SemiTrailerTruck = <any>'Sleper',
}
